<app-header></app-header>
<!-- <main> -->
<!-- <app-sidebar></app-sidebar> -->
<anais-banner></anais-banner>
<router-outlet></router-outlet>
<!-- </main> -->
<!-- <app-footer></app-footer> -->
